import React from 'react'
import EstimationManagement from './abstract/EstimationManagement'

import EstimationActions from '../../libs/EstimationActions'
import EstimationSchema from '../../libs/EstimationSchema'

import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import PageHeader from '../../components/PageHeader'

class EstimationSetupDialog extends EstimationManagement {
  constructor (props) {
    super(props)
    this.state = {
      isEstimationCategoryLoaded: false,
      isLoaded: false,
      category: 'default',
      title: ''
    }
  }
  componentWillMount () {
    const {params} = this.props.match
    const fromId = params.fromId
    if (fromId) {
      this.loadEstimation(fromId)
      const targetEstimationType = params.targetEstimationType
      this.loadEstimationCategoryList(targetEstimationType)
    } else {
      this.loadEstimationCategoryList()
      this.setState({
        isLoaded: true
      })
    }
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  copyEstimation (fromId, targetEstimationType) {
    const isTemplate = (targetEstimationType === 'template')
    const estimationNameCaption = isTemplate ? '雛型の名称(会社名)' : '見積書の名称(工事名称)'
    if (this.state.title === '') {
      Window.alert(estimationNameCaption + 'を入力してください')
      return false
    }
    const estimationData = EstimationActions.getCurrentEstimation() // componentWillMountでload済み
    estimationData.estimationType = targetEstimationType
    estimationData.estimationCategoryId = this.state.category
    if (isTemplate) {
      estimationData.estiamtionprimeContractor = this.state.title
    } else {
      estimationData.estimationTitle = this.state.title
    }
    estimationData.estimationId = this.uuid()
    this.saveEstimation(estimationData, 'copy')
  }
  createBlankEstimation (targetEstimationType) {
    const isTemplate = (targetEstimationType === 'template')
    const estimationNameCaption = isTemplate ? '雛型の名称(会社名)' : '見積書の名称(工事名称)'
    if (this.state.title === '') {
      Window.alert(estimationNameCaption + 'を入力してください')
      return false
    }
    const newEstimation = {}
    EstimationSchema.forEach(item => {
      newEstimation[item.id] = item.default
      if (item.id === 'estimationType') {
        newEstimation[item.id] = this.estimationType
      }
      if (item.id === 'estimationCategoryId') {
        newEstimation[item.id] = this.state.category
      }
      if (item.id === 'estimationId') {
        newEstimation[item.id] = this.uuid()
      }
      if (item.id === 'estimationTitle') {
        newEstimation[item.id] = !isTemplate ? this.state.title : null
      }
      if (item.id === 'estiamtionprimeContractor') {
        newEstimation[item.id] = isTemplate ? this.state.title : null
      }
    })
    newEstimation['uchiwakeList'] = EstimationActions.getUchiwakeSetting()
    const newDataWithPrefecture = EstimationActions.selectPrefecture(newEstimation, 'estimationPrefectureId', newEstimation['estimationPrefectureId'])
    const nowDate = new Date()
    const newDataWithPrefectureAndRyouritsu = EstimationActions.selectYearMonth(newDataWithPrefecture, 'estimationYearMonthId', nowDate.getFullYear() * 100 + (nowDate.getMonth() + 1))
    this.saveEstimation(newDataWithPrefectureAndRyouritsu, 'createBlankEstimation')
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const {params} = this.props.match
    const fromId = params.fromId
    switch (name) {
      case 'save':
        if (fromId) {
          const targetEstimationType = params.targetEstimationType
          this.copyEstimation(fromId, targetEstimationType)
        } else {
          const estimationType = params.estimationType
          this.createBlankEstimation(estimationType)
        }
        break
      case 'cancel':
        if (fromId) {
          this.props.history.push('/company_user/estimation/' + this.estimationType + '/copy/' + fromId)
        } else {
          this.props.history.push('/company_user/estimation/' + this.estimationType)
        }
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isEstimationCategoryLoaded || !this.state.isLoaded) {
      return <Loading />
    }
    const options = this.state.categoryList.map((category) => (<option key={category.id} value={category.id}>{category.name}</option>))
    const {params} = this.props.match
    let targetEstimationType = params.targetEstimationType
    if (!targetEstimationType) {
      targetEstimationType = this.estimationType
    }
    const isTemplate = (targetEstimationType === 'template')

    const estimationTypeCaption = isTemplate ? '雛型' : '見積書'
    const pageHeaderMain = estimationTypeCaption + 'の新規作成'
    const pageHeaderSub = 'こちらから' + estimationTypeCaption + 'の新規作成ができます。'
    const estimationNameCaption = isTemplate ? '雛型の名称(会社名)' : '見積書の名称(工事名称)'
    return (
      <div>
        <PageHeader title={pageHeaderMain} sub={pageHeaderSub} history={this.props.history}>
          <ul className='nav nav-pills kw-page-actions'>
            <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onFormButtonClicked('cancel', e)}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
          </ul>
        </PageHeader>
        <section id='my-account-security-form' className='page container'>
          <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={(e) => this.onFormButtonClicked('save', e)}>
            <div className='container'>
              <div className='alert alert-block alert-info'>
                <p>
                  必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。
                </p>
              </div>
              <div id='acct-password-row'>
                <fieldset className='kw-pr-reset-area'>
                  <legend>{estimationTypeCaption}の新規作成</legend><br />
                  <div className='control-group'>
                    <label className='control-label'>{estimationTypeCaption}カテゴリー <span className='required'>*</span></label>
                    <div className='controls'>
                      <select ref='estimationCategory' value={this.state.category} onChange={(e) => this.changed('category', e)}>
                        {options}
                      </select>
                    </div>
                  </div>
                  <div className='control-group'>
                    <label className='control-label'>{estimationNameCaption} <span className='required'>*</span></label>
                    <div className='controls'>
                      <input ref='estimationTitle' className='span4' type='text' autoComplete='false' onChange={(e) => this.changed('title', e)} />
                    </div>
                  </div>
                </fieldset>
              </div>
              <footer id='submit-actions' className='form-actions'>
                <button type='submit' className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)}>保存</button>
                <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
              </footer>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default EstimationSetupDialog



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationSetupDialog.js